import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-uxa8001c',
  templateUrl: './uxa8001c.component.html',
  styleUrls: ['./uxa8001c.component.scss']
})
export class Uxa8001cComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
